import { htmlProfit } from "@components/modals/modal-messages/financial/Profit";

export function Modal4Test() {
  return htmlProfit();
}
